import { render } from "./ThongTinManHinhNgang.vue?vue&type=template&id=6e465ede&scoped=true"
import script from "./ThongTinManHinhNgang.vue?vue&type=script&lang=js"
export * from "./ThongTinManHinhNgang.vue?vue&type=script&lang=js"

import "./ThongTinManHinhNgang.vue?vue&type=style&index=0&id=6e465ede&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e465ede"]])

export default __exports__